import { useEffect, useState } from 'react';
import { Timestamp } from '@framework/Timestamp';

const UPDATE_INTERVAL_MS = 60 * 1000;

/**
 * 現在時刻を返し、1分ごとに更新します。
 * 相対時刻表示の自動更新に使用します。
 */
export const useNow = (): Timestamp => {
  const [now, setNow] = useState(() => Timestamp.now());

  useEffect(() => {
    const id = setInterval(() => setNow(Timestamp.now()), UPDATE_INTERVAL_MS);
    return () => clearInterval(id);
  }, []);

  return now;
};
